module.exports = __webpack_public_path__ + "static/img/modern-light.66651c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/modern-light.png
// module id = woOV
// module chunks = 58